import { HEADER_OPTIONS_MAX_LENGTH } from '../consts';
import { i18n as rosetta } from '../../libs/i18n';
import { getSellHouseOptionsBySheetName } from './i18n.utils';
import { SearchOption, getCountySearchOptions } from './searchOption.utils';

export type SellHouseOption = {
  query: string;
  text: string;
};

const sheetName = 'sellHousePage';

export const computeSellHouseOptions = (
  searchOptions: SearchOption[],
  includeNonCountyOptions = false
): SellHouseOption[] => {
  const filteredSearchOptions = includeNonCountyOptions
    ? searchOptions
    : getCountySearchOptions(searchOptions);
  return getSellHouseOptionsBySheetName(filteredSearchOptions, sheetName).slice(
    0,
    includeNonCountyOptions ? undefined : HEADER_OPTIONS_MAX_LENGTH
  );
};

export const getHighlightedBannerCount = (query: string): number => {
  let highlightedBannersCount = 0;
  for (let i = 1; i <= 4; i++) {
    if (
      rosetta.t(`dynamic.${sheetName}.${query}.highlightedBannerTitle_${i}`)
    ) {
      highlightedBannersCount = i;
    } else {
      break;
    }
  }
  return highlightedBannersCount;
};
